module.exports = __webpack_public_path__ + "img/荣誉证书01_企业信用等级证书.300c0157.png";